export default "__VITE_ASSET__ClaRbciV__"